import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuditoriaList from '../views/area/auditoria/List.vue';
import ClienteOcultoList from '../views/area/cliente_oculto/List.vue';
import VisitaList from '../views/area/relatorio/List.vue';
import ListValidadeProduto from '../views/area/relatorio/ListValidadeProduto.vue';
import ListArquivo from '../views/area/arquivos/List.vue';
import DashBoard from '../views/area/dashboard/index';
import Graficos from '../views/area/graficos/index';
import Auth from './auth';
import authPages from './auth_pages';

const routesPerfilCliente =
{
        path: "/area",
        component: DashboardLayout,
        beforeEnter: Auth,
        children: [
                {
                        path: "/area",
                        name: "Dashboard",
                        components: { default: DashBoard }
                },
                {
                        path: "/area/dashboard",
                        name: "Dashboard",
                        components: { default: DashBoard }
                },

                {
                        path: "/area/auditoria",
                        name: "Auditoria Técnica",
                        components: { default: AuditoriaList }
                },
                {
                        path: "/area/cliente_oculto",
                        name: "Cliente Oculto",
                        components: { default: ClienteOcultoList }
                },
                {
                        path: "/area/visita",
                        name: "Visita Técnica",
                        components: { default: VisitaList }
                },
                {
                        path: "/area/validade",
                        name: "Validade Produto",
                        components: { default: ListValidadeProduto }
                },
                {
                        path: "/area/documentos",
                        name: "Documentos",
                        components: { default: ListArquivo }
                },
                {
                        path: "/area/grafico",
                        name: "Gráfico Unidades",
                        components: { default: Graficos }
                }
        ]
}


export default routesPerfilCliente;